import React, { Component } from 'react';
import { ListGroup, Row, Col, Button } from 'react-bootstrap';

import { addInvited, removeInvited } from '../../actions/index';
import { connect } from 'react-redux';
import InvitedAdd from "./InvitedAdd";
import { translate } from "react-i18next";

class InvitedList extends Component {

    constructor(props) {
        super(props);

        this.removeInvited = this.removeInvited.bind(this);
    }

    removeInvited(invited) {
        this.props.removeInvited(invited);
        this.props.updateModel("inviteds", invited, 'INVITED_REMOVE');
        let oldState = this.state;
        this.setState({
            ...oldState,
            activePage: 1
        });
    }


   

    render() {
        return (
            <div>
                <ListGroup >
                    {this.props.inviteds.map((invited) => {
                        return (
                            <ListGroup.Item key={invited.email} variant="success">
                                <Row >
                                    <Col lg={4} xs={4}>{invited.username}</Col>
                                    <Col lg={4} xs={6}>{invited.email}</Col>
                                    <Col lg={4} xs={2}>
                                        <Button variant="outline-primary" onClick={() => this.removeInvited(invited)}><span class="fa fa-trash-alt"></span></Button>
                                    </Col>
                                </Row>
                            </ListGroup.Item>
                        )
                    })}
                </ListGroup>

               
                <InvitedAdd onAdd={(user) => {
                    this.props.addInvited(user);
                    this.props.updateModel("inviteds", user, 'INVITED_ADD');
                }} />
            </div>
        )
    }
}

let mapStateToProps = (state) => {
    return {
        inviteds: state.inviteds
    }
}

let mapDispatchToProps = {
    addInvited: addInvited,
    removeInvited: removeInvited
}

let InvitedListContainer =
    connect(mapStateToProps, mapDispatchToProps)(InvitedList);

export default translate("translations")(InvitedListContainer);